import React from 'react';
import DailyReportsComponent from '../DailyReports';

const DailyReports = () => (
  <div>
    <DailyReportsComponent />
  </div>
);

export default DailyReports;
